import { ChangeProjectStatusPromptProps } from './ChangeProjectStatusPromptProps';
import React, { FC } from 'react';
import Modal, { ModalFooter, Prompt } from '@ingka/modal';
import Button from '@ingka/button';
import { IconButton, Stack } from '@mui/material';
import Select, { Option } from '@ingka/select';
import useTranslation from '../../hooks/useTranslation';
import SSRIcon from '@ingka/ssr-icon';
import cross from '@ingka/ssr-icon/paths/cross';

const ChangeProjectStatusPrompt: FC<ChangeProjectStatusPromptProps> = ({
  isVisible,
  onClose,
  onCancel,
  onAccept,
  selectedStatus,
  onStatusChange,
  allowedStatuses,
}) => {
  const t = useTranslation();
  return (
    <Modal
      handleCloseBtn={onClose}
      visible={isVisible}
      data-testid={'change-project-status-modal'}
    >
      <Prompt
        aria-label="Accessibility header for a modal"
        className="example-prompt-override"
        header={null}
        titleId={'change-project-status-modal-title'}
        footer={
          <ModalFooter>
            <Stack direction={'row'} spacing={2} width={'100%'}>
              <Button
                style={{ marginBottom: 0 }}
                text={t('common.cancel')}
                data-testid={'change-status-cancel'}
                type="secondary"
                onClick={onCancel}
              />
              <Button
                text={t('common.changeStatus')}
                data-testid={'change-status-accept'}
                type="primary"
                onClick={onAccept}
              />
            </Stack>
          </ModalFooter>
        }
        title={
          <Stack direction={'row'} justifyContent={'space-between'} pt={3}>
            <Stack flex={1}>{t('common.changeStatus')}</Stack>
            <IconButton
              onClick={onClose}
              sx={(theme) => ({
                position: 'absolute',
                top: theme.spacing(2),
                right: theme.spacing(2),
              })}
            >
              <SSRIcon paths={cross} />
            </IconButton>
          </Stack>
        }
      >
        <Stack>
          <p>{t('common.changeStatusDescription')}</p>
          <Select
            id={'project-status-selector'}
            data-testid={'project-status-selector'}
            label={'Status'}
            value={selectedStatus}
            onChange={(e) => onStatusChange(e.target.value)}
          >
            {allowedStatuses.map((opt, index) => (
              <Option
                key={opt + Math.random() * index}
                value={opt}
                selected
                name={t('statuses')[opt]}
              />
            ))}
          </Select>
        </Stack>
      </Prompt>
    </Modal>
  );
};

export default ChangeProjectStatusPrompt;
